export default __webpack_public_path__ + "static/badge-green-f19ecd24f688baf8929739d5250228c0.png";